import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'

interface TotalsItemModel {
  alias: string
  detail: string
  totalAmount: string
}

enum UppercaseEnum {
  IRPF = 'IRPF'
}

// DEFINE PROPS  ======================================================================================================

export default /*#__PURE__*/_defineComponent({
  __name: 'LfTotalsComponent',
  props: {
  items: {
    type: Array as PropType<TotalsItemModel[]>,
    default: () => []
  }
},
  setup(__props) {



function getDetailClass (detail: string): string {
  return Object.values(UppercaseEnum).includes(detail as UppercaseEnum)
    ? 'uppercaseText' : 'capitalizeText'
}


return { __sfc: true,UppercaseEnum, getDetailClass }
}

})